import { render, staticRenderFns } from "./UserForm.vue?vue&type=template&id=24272b7c&scoped=true"
import script from "./UserForm.vue?vue&type=script&lang=js"
export * from "./UserForm.vue?vue&type=script&lang=js"
import style0 from "./UserForm.vue?vue&type=style&index=0&id=24272b7c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24272b7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24272b7c')) {
      api.createRecord('24272b7c', component.options)
    } else {
      api.reload('24272b7c', component.options)
    }
    module.hot.accept("./UserForm.vue?vue&type=template&id=24272b7c&scoped=true", function () {
      api.rerender('24272b7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/referentiel/user/UserForm.vue"
export default component.exports